import React from 'react'
import ImageData from '../../types/ImageData'

export type ImageProps = Omit<
  React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>,
  'src' | 'width' | 'height'
> & {
  image?: ImageData
  responsive?: boolean
}

const Image: React.FC<ImageProps> = ({ image, responsive, className, ...props }) => {
  return (
    <img
      {...props}
      className={[!!responsive && 'img-responsive', className].filter((x) => !!x).join(' ')}
      src={image?.url}
      width={image?.width}
      height={image?.height}
      alt={props.alt ?? image?.alt ?? ''}
    />
  )
}

export default Image
